export function isHttpUrl(url?: string | null): url is string {
  return !!url && (url.startsWith("http://") || url.startsWith("https://"));
}

/**
 * Live-link Return to app: cash-deposit host handoff first, then envelope
 * callbackUrl. Never sessionExpiredRedirectUrl (that is 410/409 only).
 */
export function resolveLiveExitUrl(session: {
  config?: { callbackUrl?: string };
  callbackUrl?: string;
} | null | undefined): string | undefined {
  const configUrl = session?.config?.callbackUrl?.trim();
  if (isHttpUrl(configUrl)) return configUrl;
  const envelope = session?.callbackUrl?.trim();
  if (isHttpUrl(envelope)) return envelope;
  return undefined;
}
